/* eslint-disable import/extensions */
import Flickity from "flickity";
import "flickity/css/flickity.css";
import "./made-product-card-carousel.scss";
import { init as initDesignProjectCarousel } from "components/design_project_carousel/component";
import createProductCardDates from "../product-card-dates";

export class UserSectionsCarouselClass {
  #flickityConfig = {
    cellAlign: "left",
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    adaptiveHeight: true,
    imagesLoaded: true
  };

  #deliveryDateClass;

  #favoritesFlickity = null;

  #orderedItemsFlickity = null;

  constructor() {
    this.#deliveryDateClass = createProductCardDates();
  }

  #initCarousel(selector, sectionId) {
    const $container = document.querySelector(selector);
    if (!$container) return null;

    const flickity = new Flickity($container, this.#flickityConfig);

    if (sectionId) {
      this.#deliveryDateClass.setupCarouselListeners(flickity, sectionId);
    }

    return flickity;
  }

  destroy() {
    if (this.#favoritesFlickity) {
      this.#favoritesFlickity.destroy();
      this.#favoritesFlickity = null;
    }
    if (this.#orderedItemsFlickity) {
      this.#orderedItemsFlickity.destroy();
      this.#orderedItemsFlickity = null;
    }
  }

  init() {
    // Initialize all carousels that exist (for initial page load)
    this.initFavorites();
    this.initOrderedItems();
    // Initialize delivery dates once after all carousels are initialized
    this.#deliveryDateClass.init();
  }

  initFavorites() {
    // Destroy existing instance if element is detached from DOM (e.g., after AJAX innerHTML replacement)
    if (this.#favoritesFlickity) {
      try {
        const { element } = this.#favoritesFlickity;
        if (element && document.contains(element)) {
          // Instance is still valid, no need to reinitialize
          return;
        }
      } catch (error) {
        // Element access failed, instance may be destroyed
      }
      // Element is detached or invalid, destroy and reinitialize
      this.#favoritesFlickity.destroy();
      this.#favoritesFlickity = null;
    }

    this.#favoritesFlickity = this.#initCarousel(".js-favorites-swiper", "favorites");
  }

  initOrderedItems() {
    // Destroy existing instance if element is detached from DOM (e.g., after AJAX innerHTML replacement)
    if (this.#orderedItemsFlickity) {
      try {
        const { element } = this.#orderedItemsFlickity;
        if (element && document.contains(element)) {
          // Instance is still valid, no need to reinitialize
          return;
        }
      } catch (error) {
        // Element access failed, instance may be destroyed
      }
      // Element is detached or invalid, destroy and reinitialize
      this.#orderedItemsFlickity.destroy();
      this.#orderedItemsFlickity = null;
    }

    this.#orderedItemsFlickity = this.#initCarousel(".js-ordered-items-swiper", "ordered-items");
  }

  // Initialize delivery dates (called after carousel initialization)
  initDeliveryDates() {
    this.#deliveryDateClass.init();
  }

  // Expose flickity instances for cleanup (needed for AJAX reloads)
  get favoritesFlickity() {
    return this.#favoritesFlickity;
  }

  get orderedItemsFlickity() {
    return this.#orderedItemsFlickity;
  }
}

const userSectionsCarouselClass = new UserSectionsCarouselClass();

// Expose globally for AJAX-loaded content
window.userSectionsCarouselClass = userSectionsCarouselClass;
window.initDesignProjectCarousel = initDesignProjectCarousel;

document.addEventListener("DOMContentLoaded", () => {
  initDesignProjectCarousel();
  userSectionsCarouselClass.init();
});

export default () => new UserSectionsCarouselClass();
